module.exports = __webpack_public_path__ + "static/media/partitions_gwp_60y_y.f47df7fc.csv";